/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventIndex: NonNullable<unknown> }} Event_Transcript_Preview_Aria_LabelInputs */

const en_event_transcript_preview_aria_label = /** @type {(inputs: Event_Transcript_Preview_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Transcript Editor Preview for event ${i?.eventIndex}`)
};

const fr_event_transcript_preview_aria_label = /** @type {(inputs: Event_Transcript_Preview_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apercu de l'editeur de transcription pour l'evenement ${i?.eventIndex}`)
};

const de_event_transcript_preview_aria_label = /** @type {(inputs: Event_Transcript_Preview_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vorschau des Transkripteditors für Ereignis ${i?.eventIndex}`)
};

const it_event_transcript_preview_aria_label = /** @type {(inputs: Event_Transcript_Preview_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anteprima dell'editor di trascrizione per l'evento ${i?.eventIndex}`)
};

const ru_event_transcript_preview_aria_label = /** @type {(inputs: Event_Transcript_Preview_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр стенограммы мероприятия ${i?.eventIndex} в редакторе.`)
};

const es_event_transcript_preview_aria_label = /** @type {(inputs: Event_Transcript_Preview_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vista previa del editor de transcripciones para el evento ${i?.eventIndex}`)
};

const zh_cn2_event_transcript_preview_aria_label = /** @type {(inputs: Event_Transcript_Preview_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`活动 ${i?.eventIndex} 的文字稿编辑器预览`)
};

const ja_event_transcript_preview_aria_label = /** @type {(inputs: Event_Transcript_Preview_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.eventIndex} のトランスクリプト エディター プレビュー`)
};

const hi_event_transcript_preview_aria_label = /** @type {(inputs: Event_Transcript_Preview_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.eventIndex} के लिए ट्रांसक्रिप्ट एडिटर का पूर्वावलोकन`)
};

const pt_pt2_event_transcript_preview_aria_label = /** @type {(inputs: Event_Transcript_Preview_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pré-visualização do Editor de Transcrição para o evento ${i?.eventIndex}`)
};

/**
* | output |
* | --- |
* | "Transcript Editor Preview for event {eventIndex}" |
*
* @param {Event_Transcript_Preview_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_transcript_preview_aria_label = /** @type {((inputs: Event_Transcript_Preview_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Transcript_Preview_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_transcript_preview_aria_label(inputs)
	if (locale === "de") return de_event_transcript_preview_aria_label(inputs)
	if (locale === "it") return it_event_transcript_preview_aria_label(inputs)
	if (locale === "ru") return ru_event_transcript_preview_aria_label(inputs)
	if (locale === "es") return es_event_transcript_preview_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_transcript_preview_aria_label(inputs)
	if (locale === "ja") return ja_event_transcript_preview_aria_label(inputs)
	if (locale === "hi") return hi_event_transcript_preview_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_transcript_preview_aria_label(inputs)
	return en_event_transcript_preview_aria_label(inputs)
});